<h1>{{data.action}}?</h1>
<div>
    {{data.description}}
</div>
<div class="buttons">
    <button id="cancel" (click)="cancel()" (keydown.enter)="cancel($event)">Cancel</button>
    <button id="confirm" (click)="confirm()" (keydown.enter)="confirm($event)">{{data.action}}</button>
</div>